import { Box, Button, Paper, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { getHomePathForRole } from "../../utils/rolePaths";

export default function Unauthorized() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const from = location.state?.from?.pathname || "";

  return (
    <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center" sx={{ background: "#101820" }}>
      <Paper sx={{ p: 4, maxWidth: 440, width: "90vw", textAlign: "center" }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Access denied
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You do not have permission to open{" "}
          <Typography component="span" variant="body1" fontWeight="600">
            {from || "this page"}
          </Typography>
          . If you believe this is a mistake, contact an administrator.
        </Typography>
        <Button variant="contained" color="secondary" onClick={() => navigate(getHomePathForRole(user?.role), { replace: true })}>
          Go to your home
        </Button>
      </Paper>
    </Box>
  );
}
